var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center align-center"},[_c('div',{staticClass:"py-8"},[_c('v-img',{attrs:{"alt":_vm.imgAlt,"src":require(("@/assets/img/" + _vm.imgSrc)),"height":_vm.imgHeight,"width":_vm.imgWidth}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }